import { render } from "./ContactsModal.vue?vue&type=template&id=791e60e2"
import script from "./ContactsModal.vue?vue&type=script&lang=js"
export * from "./ContactsModal.vue?vue&type=script&lang=js"

import "./ContactsModal.vue?vue&type=style&index=0&id=791e60e2&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__